import { useEffect, useState } from "react"
import fileService from "../Services/fileService"
import toast from "react-hot-toast"
import { useLocation, useNavigate } from "react-router-dom"

const useManifest = (data: {nin: any, workflow: any}) => {
  const location: any = useNavigate()
  const locations = useLocation()
  const [manifestInfo, setManifestInfo] = useState<any>()
  const askForManifest = async () => {
    try {
      const response = await fileService.askForManifest({ ...data, profileFetchMode: 2 })
      // console.log("Manifest response:", response)
      if (response.status === 200 || response.status === 304) {
        const resData = response.data
        setManifestInfo(resData)
      }
    } catch (error: any) {
      // console.log("Manifest error", error)
      if (error.response.data.status === 'error') {
        toast.error(error.response.data.message)
        locations.state = {}
        location('/')
      }
      toast.error("Manifest information not available at the moment, please contact support")
    }
  }
  useEffect(() => {
    askForManifest()
  }, [])

  return { manifestInfo, askForManifest }
}
export default useManifest
